import { render, staticRenderFns } from "./DepartmentTripleCards.vue?vue&type=template&id=3112b44d&scoped=true"
import script from "./DepartmentTripleCards.vue?vue&type=script&lang=js"
export * from "./DepartmentTripleCards.vue?vue&type=script&lang=js"
import style0 from "./DepartmentTripleCards.vue?vue&type=style&index=0&id=3112b44d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3112b44d",
  null
  
)

export default component.exports